<script setup lang="ts">
import type { NuxtError } from '#app'

const { t } = useI18n()
const router = useRouter()
const localePath = useLocalePath()

useSeoMeta({
  title: t('Introfy® - Fehler'),
})

const props = defineProps({
  error: {
    type: Object as PropType<NuxtError>,
    required: false,
  },
})
</script>

<template>
  <div class="bg-surface-0 flex flex-col items-center justify-center py-16">
    <div class="flex flex-col items-center">
      <img
        src="/logo.svg"
        class="w-auto h-14 mb-16"
        alt="Logo"
      >
      <p class="text-5xl font-bold text-surface-900 mb-4">
        {{ props.error?.statusCode }}
      </p>
      <p class="text-xl text-surface-700">
        {{ t("Es ist ein Fehler aufgetreten.") }}
      </p>
      <Button
        class="mt-16"
        :label="t('Zurück zur Startseite')"
        @click="router.push(localePath('landing'))"
      />
    </div>
  </div>
</template>
